import { create } from 'zustand';
import { MapState } from '../types';
import { odysseyLocations } from '../data/locations';

export const useMapStore = create<MapState>((set, get) => ({
  selectedLocation: null,
  setSelectedLocation: (location) => {
    set({ selectedLocation: location });
    if (location) {
      get().markAsExplored(location.id);
    }
  },

  activeFilter: 'all',
  setActiveFilter: (filter) => set({ activeFilter: filter }),

  viewMode: 'map',
  setViewMode: (mode) => set({ viewMode: mode }),

  searchQuery: '',
  setSearchQuery: (query) => set({ searchQuery: query }),

  exploredLocations: new Set<number>(),
  markAsExplored: (id) =>
    set((state) => ({
      exploredLocations: new Set(state.exploredLocations).add(id),
    })),

  // Journey Playback State
  isJourneyPlaying: false,
  currentJourneyIndex: 0,
  setIsJourneyPlaying: (playing) => set({ isJourneyPlaying: playing }),
  setCurrentJourneyIndex: (index) => set({ currentJourneyIndex: index }),
  playJourney: () => set({ isJourneyPlaying: true }),
  pauseJourney: () => set({ isJourneyPlaying: false }),
  resetJourney: () => set({ isJourneyPlaying: false, currentJourneyIndex: 0 }),

  getFilteredLocations: () => {
    const { activeFilter, searchQuery } = get();
    let filtered = [...odysseyLocations];

    // Apply phase filter
    if (activeFilter !== 'all') {
      if (activeFilter === 'filming') {
        filtered = filtered.filter((loc) => loc.nolansFilmLocation === true);
      } else {
        filtered = filtered.filter((loc) => loc.phase === activeFilter);
      }
    }

    // Apply search query
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (loc) =>
          loc.name.toLowerCase().includes(query) ||
          loc.modernName.toLowerCase().includes(query) ||
          loc.description.toLowerCase().includes(query) ||
          loc.book.toLowerCase().includes(query)
      );
    }

    return filtered;
  },
}));
